module.exports = __webpack_public_path__ + "img/hr-dead-grey-trunk-07.c9c2f5da.png";